var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgChevronUp = function SvgSvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12,
    fill: "none",
    viewBox: "0 0 20 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 12a2 2 0 0 1-1.414-.586l-6.61-6.61-6.586 6.36a1.996 1.996 0 0 1-2.828-.05A2 2 0 0 1 .61 8.286l8-7.724a2 2 0 0 1 2.804.024l8 8A1.998 1.998 0 0 1 18 12"
  })));
};
export default SvgSvgChevronUp;